
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick } from 'vue'
import { CaretRightOutlined, VerticalAlignBottomOutlined, CaretDownOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import globalsets from '@/utils/globalsets'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
export default defineComponent({
  components: {
    VerticalAlignBottomOutlined,
    CaretRightOutlined,
    CaretDownOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    customRow: {
      type: Function,
      default: () => {
      }
    },
    setRowClassName: {
      type: Function,
      default: () => {
      }
    },
    bordered: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    pagination: {
      type: [Boolean, Object],
      default: () => {
        return false || []
      }
    },
    scroll: {
      type: Object,
      default: () => {
        return {}
      }
    },
    emptyText: {
      type: Object,
      default: () => {
        return {}
      }
    },
    expandedRowRender: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    marginStyle: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    maskName: {
      type: Function,
      default: (name: string) => name
    }
  },
  setup(props: any, context) {


    const nameCellRefs = ref({});
    const tooltipVisibleMap = ref({});
    const bkNameCellRefs = ref({});
    const bkNameTooltipVisibleMap = ref({});
    const grpNameCellRefs = ref({});
    const grpNameTooltipVisibleMap = ref({});

    function setNameCellRef(el) {
      if (el) {
        nameCellRefs.value[el.dataset.rowKey] = el;
      }
    }

    function setBkNameCellRef(el) {
      if (el) {
        bkNameCellRefs.value[el.dataset.rowKey] = el;
      }
    }

    function setGrpNameCellRef(el) {
      if (el) {
        grpNameCellRefs.value[el.dataset.rowKey] = el;
      }
    }

    function isNameTooltipVisible(record) {
      return tooltipVisibleMap.value[record.symbol] || false;
    }

    function isBkNameTooltipVisible(record) {
      return bkNameTooltipVisibleMap.value[record.index] || false;
    }

    function isGrpNameTooltipVisible(record) {
      return grpNameTooltipVisibleMap.value[record.index] || false;
    }

    function handleNameTooltipVisible(visible, record) {
      // 只在隐藏时清除状态，不在显示时设置（显示由 checkTextOverflow 控制）
      if (!visible) {
        tooltipVisibleMap.value[record.symbol] = false;
      }
    }

    function handleBkNameTooltipVisible(visible, record) {
      if (!visible) {
        bkNameTooltipVisibleMap.value[record.index] = false;
      }
    }

    function handleGrpNameTooltipVisible(visible, record) {
      if (!visible) {
        grpNameTooltipVisibleMap.value[record.index] = false;
      }
    }

    // 检查是否溢出（mouseenter 时调用）
    function checkTextOverflow(record, text) {
      const el = nameCellRefs.value[record.symbol];
      if (!el) return;
      // 比较内容真实宽度与最大宽度
      tooltipVisibleMap.value[record.symbol] = el.scrollWidth > el.offsetWidth;
    }

    function checkBkNameOverflow(record, text) {
      const el = bkNameCellRefs.value[record.index];
      if (!el) return;
      bkNameTooltipVisibleMap.value[record.index] = el.scrollWidth > el.offsetWidth;
    }

    function checkGrpNameOverflow(record, text) {
      const el = grpNameCellRefs.value[record.index];
      if (!el) return;
      grpNameTooltipVisibleMap.value[record.index] = el.scrollWidth > el.offsetWidth;
    }
    const route = useRoute()
    const store = useStore()
    const pageData: any = reactive({
      emptystr: (props as any).emptyText,
      expandedRowKeys: [],
      // getPopupContainer: (e: HTMLElement) => e.parentNode,
      getPopupContainer: (e: HTMLElement) => document.body,
      theme: props.theme || route.query.theme
    })
    pageData.emptystr = (props as any).emptyText
    const tooltip: any = reactive({})
    const overflow: any = reactive({})
    // let timer: any = null
    // function isoverflow(e: any, record: any, column: any) {
    //   const text = column.key
    //   const index = record.index
    //   tooltip[text + index] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
    //   if (tooltip[text + index]) {
    //     if (!timer) {
    //       timer = setTimeout(() => {
    //         overflow[text + index] = true
    //       }, 400)
    //     }
    //   }
    // }
    onMounted(() => {
      const lel: any = document.querySelector('.wrapper')
      lel.addEventListener('scroll', (e: any) => {
        Object.keys(overflow).map((item: any) => {
          if (overflow[item]) {
            overflow[item] = false
          }
        })
      })
    })
    function openPdf(url: string) {
      console.log(url, 'url===')
      window.open(url)

    }
    function clickTh(idx: number) {
      nextTick(() => {
        const tr = document.querySelector('.ant-table-thead tr')
        const th: any = tr && tr.getElementsByTagName('th')
        if ((th || []).length) {
          th[idx].click()
        }
      })
    }
    // function hidetool(record: any, text: string, column: any) {
    //   const index = record.index
    //   if (timer) {
    //     setTimeout(() => {
    //       overflow[column.key + index] = false
    //       window.clearTimeout(timer)
    //       timer = null
    //     })
    //   }
    // }
    function visibleChange(visible: boolean, key: string) {
      nextTick(() => {
        const dom = document.querySelector(`#${key}`)
        if (visible && dom && dom?.scrollWidth > dom?.clientWidth) {
          overflow[key] = true
        } else {
          overflow[key] = false
        }
      })
    }
    function handleClickRow(record: any, index: string, column: any) {
      return {}
    }
    // 抽屉
    function showdrawer(record: any, column: any) {
      if (column.key !== 'SHName' || record.SHName === '总计') return
      context.emit('showdrawer', { record, column })
    }
    function getRowkey(record: any, index: number) {
      return record.index
    }
    function clickexpandIcon(record: any) {
      record.onExpand(record.record)
    }
    function onExpand(a: any, b: any, c: any) {
      if (pageData.expandedRowKeys.indexOf(b.key) < 0) {
        pageData.expandedRowKeys.push(b.key)
      } else {
        pageData.expandedRowKeys.splice(pageData.expandedRowKeys.indexOf(b.key), 1)
      }
    }
    function onChange(pagination: any, filters: any, sorter: any) {
      context.emit('onChange', pagination, filters, sorter)
    }
    function gotolink(e: any, record: any, column: any) {
      // const origin = document.location.origin
      const origin =
        document.domain === 'localhost'
          ? 'https://test-pcstatic.9fh5.com'
          : document.location.origin.indexOf('pcstatic') > -1
            ? document.location.origin
            : 'https://pcstatic.sylapp.cn'
      let url = ''
      if (record.ReportID) {
        if (route.query.softNameAbbr === 'jfztGW') {
          const url = `${origin}/researchreport/index.html#/reportdetail?reportId=${record.ReportID}&softNameAbbr=jfztGW`
          store.commit('setIframeModalInfo', {
            modalsrc: url,
            modalvisible: true,
            title: record.Title,
            width: '948px'
          })
        } else {
          url = `gw://webkitdlg?width=948;height=575;mode=0;title=${record.Title};allowdestroy=1;url=${origin}/researchreport/index.html#/reportdetail?reportId=${record.ReportID}`
        }
      }
      if (column.key === 'ggTitle') {
        // 公司公告
        if (route.query.softNameAbbr === 'jfztGW') {
          const safeLink = record.Link?.replace(/^http:\/\//i, 'https://')
          store.commit('setIframeModalInfo', {
            modalsrc: safeLink,
            modalvisible: true,
            title: record.Title,
            width: '948px'
          })
        } else {
          url = `gw://webkitdlg?width=948;height=575;mode=0;title=${record.Title};allowdestroy=1;url=${record.Link}`
        }
      }
      if (column.key === 'zxTitle') {
        // 资讯
        if (route.query.softNameAbbr === 'jfztGW') {
          const url = `${origin}/researchreport/index.html#/newsdetail?id=${record.ID}&softNameAbbr=jfztGW`
          store.commit('setIframeModalInfo', {
            modalsrc: url,
            modalvisible: true,
            title: record.Title,
            width: '948px'
          })
        } else {
          url = `gw://webkitdlg?width=948;height=575;mode=0;title=${record.Title};allowdestroy=1;url=${origin}/researchreport/index.html#/newsdetail?id=${record.ID}`
        }
      }
      // 下载
      if (column.key === 'LinkAddress') {
        // 资讯
        if (route.query.softNameAbbr === 'jfztGW') {
          const url = record.LinkAddress.split('://')[0] === 'http' ? 'https://' + record.LinkAddress.split('://')[1] : `${record.LinkAddress}`
          store.commit('setIframeModalInfo', {
            modalsrc: url,
            modalvisible: true,
            title: '活动纪要',
            width: '948px'
          })
        } else {
          url = `gw://webkitdlg?width=948;height=575;mode=0;title=${'活动纪要'};allowdestroy=1;url=${record.LinkAddress}`
        }
      }
      if (url) {
        window.open(url)
      }
    }
    return {
      ...toRefs(pageData),
      tooltip,
      // isoverflow,
      overflow,
      // hidetool,
      showdrawer,
      getRowkey,
      clickexpandIcon,
      onExpand,
      onChange,
      gotolink,
      handleClickRow,
      getNumber: globalsets.getNumber,
      getNumber1: globalsets.getNumber1,
      getNumber2: globalsets.getNumber2,
      getPencent: globalsets.getPencent,
      getNumberNoUnit2: globalsets.getNumberNoUnit2,
      clickTh,
      visibleChange,
      openPdf,
      maskName: props.maskName,
      nameCellRefs,
      isNameTooltipVisible,
      handleNameTooltipVisible,
      checkTextOverflow,
      setNameCellRef,
      bkNameCellRefs,
      isBkNameTooltipVisible,
      handleBkNameTooltipVisible,
      checkBkNameOverflow,
      setBkNameCellRef,
      grpNameCellRefs,
      isGrpNameTooltipVisible,
      handleGrpNameTooltipVisible,
      checkGrpNameOverflow,
      setGrpNameCellRef
    }
  }
})
